import { Component } from 'react'
import { connect } from 'react-redux'

import { navigationPaths } from '../../constants/paths'


// NOTE: This allows for a user to sign out, without each view/component that renders the nav link having to worry about the presence of this.props.location
class SessionDestroy extends Component {

  componentDidMount() {
    this.signOut()
  }

  signOut() {
    this.props.dispatch({
      type: 'SIGN_OUT_SAGA',
      payload: {},
      callback: this.onSignOutSuccess
    })
  }

  onSignOutSuccess = () => {
    this.props.history.push({
      pathname: navigationPaths.signIn()
    })
  }

  render() {
    return null
  }

} // class SessionDestroy

export default connect(() => ({}))(SessionDestroy)
